
import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';

import Targets from './Targets';
import Saleries from './Saleries';
import SingleSaleryFull from './SingleSaleryFull';
import SingleSaleryPart from './SingleSaleryPart';



class Hr extends Component {

    render () {
        return (
            <Switch>
                <Route path="/hr/saleries/full/:id" component={ SingleSaleryFull } />
                <Route path="/hr/saleries/part/:id" component={ SingleSaleryPart } />
                <Route path="/hr/targets" exact component={ Targets } />
                <Route path="/hr/saleries" exact component={ Saleries } />
            </Switch>
        )
    }
}

export default Hr;



// WEBPACK FOOTER //
// ./src/components/Hr/index.js